import { AccountHolderWalkthroughSteps, NewAccountWalkthroughSteps } from '@/types/walkthroughs';
import {
    CompleteAccountModalContext,
    openCompleteAccountSignUpModal,
    openFeedbackModal,
    openLoginModal,
} from '@/redux/modules/modal';
import { en } from '@liveauctioneers/hammer-ui-liveauctioneers/intl/en';
import { EventContext } from '@/redux/modules/analytics';
import { Footer } from '@liveauctioneers/hammer-ui-liveauctioneers/footer';
import { getAuctionCalendarBaseUrl, getItemIdFromPath } from '@/utils/urls';
import { getBaseUrl, getPartnersBaseUrl } from '@/redux/modules/config';
import { getIsWhiteLabel, getWhiteLabelName } from '@/redux/modules/whiteLabel';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { onboardingWalkthroughCurrentStep } from '@/redux/modules/walkthroughs/walkthroughs.selectors';
import {
    setOnboardingWalkthroughOpenProperty,
    setOnboardingWalkthroughStep,
} from '@/redux/modules/walkthroughs/walkthroughs.reducer';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const HammerFooter = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const baseUrl = useAppSelector(getBaseUrl);
    const isWhiteLabel = useAppSelector(getIsWhiteLabel);
    const whiteLabelName = useAppSelector(getWhiteLabelName);
    const partnersBaseUrl = useAppSelector(getPartnersBaseUrl);
    const showFeedbackModal = useCallback(() => dispatch(openFeedbackModal()), [dispatch]);
    const { pathname } = useLocation();
    const itemId = getItemIdFromPath(pathname);
    const currentStep = useAppSelector(onboardingWalkthroughCurrentStep);

    const onLoginClicked = useCallback(
        () =>
            dispatch(
                openLoginModal({
                    eventContext: EventContext.join,
                    id: itemId,
                    itemId,
                    type: CompleteAccountModalContext.Login,
                })
            ),
        [dispatch, itemId]
    );

    const onSignUpClicked = useCallback(() => {
        dispatch(
            openCompleteAccountSignUpModal({
                eventContext: EventContext.join,
                id: itemId,
                itemId,
                type: CompleteAccountModalContext.Join,
            })
        );
        if (currentStep === AccountHolderWalkthroughSteps.Returning) {
            dispatch(setOnboardingWalkthroughOpenProperty(false));
            window.setTimeout(() => {
                dispatch(setOnboardingWalkthroughStep(NewAccountWalkthroughSteps.FirstTimeAnyPage));
            }, 400);
        }
    }, [currentStep, dispatch, itemId]);

    const props = {
        baseUrl,
        intl: en,
        isWhiteLabel,
        openFeedbackModal: showFeedbackModal,
        partnersBaseUrl,
        whiteLabelName,
    };

    return (
        <Footer
            isUserLoggedIn={userLoggedIn}
            onBrowseAuctionsClicked={() => {
                navigate(getAuctionCalendarBaseUrl());
            }}
            onLoginClicked={onLoginClicked}
            onSignUpClicked={onSignUpClicked}
            {...props}
        />
    );
};
